<template>
  <router-view />
</template>

<script>
export default {
  name: 'PlantIndex',
  data() {
    return {}
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/plant/Index.vue